import React from 'react';

interface PageHeroProps {
  title: string;
  description?: string;
  image?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ title, description, image }) => {
  return (
    <section 
      className="relative pt-32 pb-20 bg-linear-to-br from-primary-deep to-primary-main overflow-hidden"
      style={image ? { 
        backgroundImage: `linear-gradient(rgba(10, 104, 71, 0.8), rgba(122, 186, 120, 0.8)), url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      } : {}}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 drop-shadow-lg">{title}</h1>
          {description && (
            <p className="text-xl md:text-2xl text-white max-w-3xl mx-auto leading-relaxed drop-shadow-md">
              {description}
            </p>
          )}
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-20 w-32 h-32 bg-white/10 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 right-20 w-48 h-48 bg-white/10 rounded-full blur-xl"></div>
    </section>
  );
};

export default PageHero;